import React from 'react';
import history from '@AppRoutes/history';
import classnames from 'classnames';
import { useLocation } from 'react-router-dom';
import { paths } from '@AppRoutes/constants';

import './ProfileSettingsHeader.scss';

function ProfileSettingsHeader() {
  const location = useLocation();
  const routes = [
    {
      name: 'Account',
      pathName: paths.PROFILE_ACCOUNT,
    },
    {
      name: 'Profile',
      pathName: paths.PROFILE_PROFILE,
    },
    {
      name: 'Preferences',
      pathName: paths.PROFILE_PREFERENCES,
    },
  ];

  const handleMenuClick = (route) => {
    history.push(route);
  };

  return (
    <div className="profile-setting-header">
      <div className="profile-setting-header__content">
        <h1 id="profile-title" className="profile-setting-header__content_title">
          Profile
        </h1>
        <nav className="els-tabs--container" aria-label="Profile menu">
          <ul className="rx-tabs">
            {routes.map((route) => (
              <li className="rx-tab" key={route.name}>
                <a
                  data-e2e={`profile-settings-nav-${route.name}`}
                  className={classnames('els-tab-content-buttons', { active: route.pathName === location.pathname })}
                  href={route.pathName}
                  onClick={(e) => {
                    e.preventDefault();
                    handleMenuClick(route.pathName);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleMenuClick(route.pathName);
                    }
                  }}>
                  {route.name}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
}

export default ProfileSettingsHeader;
